var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexaTradingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1455_950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.60598 3.36486C6.07008 3.09691 6.64187 3.09691 7.10598 3.36486L9.79492 4.91732C10.259 5.18527 10.5449 5.68046 10.5449 6.21636V9.32128C10.5449 9.85718 10.259 10.3524 9.79492 10.6203L7.10598 12.1728C6.64188 12.4407 6.07008 12.4407 5.60598 12.1728L2.91703 10.6203C2.45293 10.3524 2.16703 9.85718 2.16703 9.32128V6.21636C2.16703 5.68046 2.45293 5.18527 2.91703 4.91732L5.60598 3.36486Z",
    fill: "none",
    stroke: "#FFFDF0",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9473 6.22676C12.5661 5.8695 13.3285 5.8695 13.9473 6.22676L16.6362 7.77923C17.255 8.13649 17.6362 8.79675 17.6362 9.51128V12.6162C17.6362 13.3307 17.255 13.991 16.6362 14.3483L13.9473 15.9007C13.3285 16.258 12.5661 16.258 11.9473 15.9007L9.25834 14.3483C8.63954 13.991 8.25834 13.3307 8.25834 12.6162V9.51128C8.25834 8.79675 8.63954 8.13649 9.25834 7.77923L11.9473 6.22676Z",
    fill: "#FFFDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1973 6.65978C12.6614 6.39183 13.2332 6.39183 13.6973 6.65978L16.3862 8.21224C16.8503 8.48019 17.1362 8.97538 17.1362 9.51128V12.6162C17.1362 13.1521 16.8503 13.6473 16.3862 13.9152L13.6973 15.4677C13.2332 15.7357 12.6614 15.7357 12.1973 15.4677L9.50834 13.9152C9.04424 13.6473 8.75834 13.1521 8.75834 12.6162V9.51128C8.75834 8.97538 9.04424 8.48019 9.50834 8.21224L12.1973 6.65978Z",
    stroke: "#FFFDF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1455_950",
    x: -8.33301,
    y: -7.33594,
    width: 29.3779,
    height: 30.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.945098 0 0 0 0 0.447059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1455_950"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1455_950",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: -1.7417,
    y: -4.04102,
    width: 29.3779,
    height: 30.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.945098 0 0 0 0 0.447059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexaTradingIcon);
export default __webpack_public_path__ + "static/media/HexaTradingIcon.8cd5feb4e449f58c68ee62f9cf6bb8ae.svg";
export { ForwardRef as ReactComponent };